import {
  LINK_ADMIN_ADD,
  LINK_ADMIN_ANALYTICS,
  LINK_ADMIN_DASHBOARD, LINK_ADMIN_PARTNERS,
  LINK_ADMIN_RULES, LINK_ADMIN_SETTINGS, LINK_ADMIN_STATEMENTS,
  LINK_ADMIN_TRX, LINK_ADMIN_WITHDRAWS,
} from '../../../constants/links';

import {
  getAdminLink,
  getAdminCustomersLink,
  getAdminRetailersLink
} from '../../../utils/adminLinkCtor';

const formPath = (formFN) => (...args) => `^${formFN(...args)}?$`

const getId = (idName = 'id') => `/([^/]+):${idName}?`;

const formAdminPath = formPath(getAdminLink);
const formCustomerPath = formPath(getAdminCustomersLink);
const formRetailersPath = formPath(getAdminRetailersLink);

export default [
  [formAdminPath(LINK_ADMIN_DASHBOARD), {
    title: 'Dashboard',
    main: require('../../../components/pages/Admin/Dashboard/'),
    v2: 1,
  }],
  [formAdminPath(LINK_ADMIN_TRX), {
    title: 'Transactions',
    main: require('../../../components/pages/Admin/Transactions/'),
    v2: 1,
  }],
  // [formCustomerPath(''), {
  //   title: 'Customers',
  //   main: require('../../../components/pages/Admin/Customers/'),
  //   v2: 1,
  // }],
  // [formCustomerPath(LINK_ADMIN_ADD), {
  //   title: 'Customers',
  //   main: require('../../../components/pages/Admin/CustomersAdd/'),
  //   v2: 1,
  // }],
  // [formCustomerPath(getId(), '/'), {
  //   title: 'Customers',
  //   main: require('../../../components/pages/Admin/CustomersPage/'),
  //   v2: 1,
  // }],
  // [`/admin/customers/([^/]+):id$`, {
  //   title: 'Customers',
  //   main: require('../../../components/pages/Admin/CustomersDetails/'),
  //   v2: 1,
  // }],
  [formRetailersPath(), {
    title: 'Retailers',
    main: require('../../../components/pages/Admin/Retailers/'),
    v2: 1,
  }],
  [formRetailersPath(LINK_ADMIN_ADD), {
    title: 'Retailers',
    main: require('../../../components/pages/Admin/RetailersAdd/'),
    v2: 1,
  }],
  [formRetailersPath(getId(), '/'), {
    title: 'Retailers',
    main: require('../../../components/pages/Admin/RetailerPage/'),
    v2: 1,
  }],
  [formAdminPath(LINK_ADMIN_STATEMENTS), {
    title: 'Statements',
    main: require('../../../components/pages/Admin/Statements/'),
    v2: 1,
  }],
  [formAdminPath(LINK_ADMIN_RULES), {
    title: 'GlobalRules',
    main: require('../../../components/pages/Admin/GlobalRules/'),
    v2: 1,
  }],
  // [formAdminPath(LINK_ADMIN_PARTNERS), {
  //   title: 'Partners',
  //   main: require('../../../components/pages/Admin/Partners/'),
  //   v2: 1,
  // }],
  // [formAdminPath(LINK_ADMIN_ANALYTICS), {
  //   title: 'Analytics',
  //   main: require('../../../components/pages/Admin/Analytics/'),
  //   v2: 1,
  // }],
  // [formAdminPath(LINK_ADMIN_SETTINGS), {
  //   title: 'Settings',
  //   main: require('../../../components/pages/Admin/Settings/'),
  //   v2: 1,
  // }]
];
